export const environment = {
  production: true,
  showBoardPack: true,
  disableSentry: false,
}
